import {type MaskOptions} from '@wandb/weave/common/types/media';
import {get} from 'lodash';

import {type ClassLabelMap, type ClassLabelNode} from '../../../util/media';
import {type MediaBrowserPanelConfig} from '../common';
import {defaultLayout} from '../utils/maskControlUtils';
import {type Tile, type TileWithMaskOptions} from './types';

// Move getMaskOptions here to break the cycle
export function getMaskOptions(
  config: Omit<MediaBrowserPanelConfig, 'chartTitle'>,
  allMasks: {
    [mediaKey: string]: {
      [maskKey: string]: ClassLabelNode;
    };
  },
  t: Tile
): MaskOptions[] {
  const maskKeys = Object.keys(allMasks[t.mediaKey] ?? {});
  const tileLayout = get(
    config,
    ['tileLayout', t.mediaKey],
    defaultLayout(maskKeys)
  ) as {
    type: string;
    maskOptions: MaskOptions[];
  };
  return tileLayout.maskOptions;
}

type GetTilesWithMaskOptionsParams = {
  config: Omit<MediaBrowserPanelConfig, 'chartTitle'>;
  allMasks: ClassLabelMap;
  tiles: Tile[];
};

// Expands each tile into multiple based on the mask layout
export function getTilesWithMaskOptions({
  config,
  allMasks,
  tiles,
}: GetTilesWithMaskOptionsParams): TileWithMaskOptions[] {
  const tilesWithMaskOptions: TileWithMaskOptions[] = [];

  for (const t of tiles) {
    const maskOptions = getMaskOptions(config, allMasks, t);
    const maskOptionsForTile = maskOptions.map(mo => ({...t, maskOptions: mo}));
    tilesWithMaskOptions.push(...maskOptionsForTile);
  }

  return tilesWithMaskOptions;
}
